import { Classes, Dialog } from "@blueprintjs/core";
import { FieldGroup } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import * as Yup from "yup";

import {
  DemandeInscriptionFichierUploadDto,
  DemandeInscriptionFichierUploadDtoFromJSON,
  ParcoursFormationApi
} from "../../../../../../api";
import { FGWalterFileInput, SmallFormGenerator } from "../../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";

const StyledDialog = styled(Dialog)`
  width: 600px;
  height: auto;
  background-color: white;
`;

export interface IDemandeInscriptionDocumentUploadDialogProps {
  iddemandeInscription: number;
  dialogOpen: boolean;
  onClose: (refresh?: boolean) => void;
}

export const DemandeInscriptionDocumentUploadDialog: React.FunctionComponent<IDemandeInscriptionDocumentUploadDialogProps> = ({
  iddemandeInscription,
  dialogOpen,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(ParcoursFormationApi);

  const { data, loading, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => {
          return DemandeInscriptionFichierUploadDtoFromJSON({ iddemandeInscription });
        },
        saveApiFn: async (d: DemandeInscriptionFichierUploadDto) => {
          return api.parcoursFormationUploadDemandeInscriptionFichier({
            DemandeInscriptionFichierUploadDto: d
          });
        },
        onSaved: () => onClose(true)
      }),
      [api, iddemandeInscription, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        file: Yup.object()
          .nullable()
          .shape({
            fileName: Yup.string()
              .nullable()
              .required(t(ETLCodes.Required)),
            contentB64: Yup.string()
              .nullable()
              .required(t(ETLCodes.Required))
          })
      }),
    [t]
  );

  return (
    <StyledDialog title={t(ETLCodes.UploadFichier)} isOpen={dialogOpen} onClose={() => onClose(false)}>
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose(false)}
          showDeleteButton={false}
          saving={saving}
          loading={loading}
          validationErrors={validationErrors}
        >
          <FieldGroup>
            <FGWalterFileInput name="file" label={t(ETLCodes.Fichier)} requiredMark />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
